import createRequest from "./requests/create-request";
import showRequest from "./requests/show-request";
import updateRequest from "./requests/update-request";
import deleteRequest from "./requests/delete-request";

const resourceRepository = {
    create: createRequest,
    show: showRequest,
    update: updateRequest,
    delete: deleteRequest,
};

export default resourceRepository;
